import { Row, Col } from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { Registration, RegistrationTotals } from '~/types/campaign';
import moment from 'moment';

const RegistrationsTable = ({
  registrations,
  registrationTotals,
}: {
  registrations: Registration[];
  registrationTotals: RegistrationTotals;
}) => {
  if (!registrations || !registrationTotals) {
    return <div />;
  }
  const { item_totals, additional_campaign_amounts } = registrationTotals;

  const grandTotal =
    registrations.reduce((acc, item) => {
      return acc + parseFloat(item.total);
    }, 0) + additional_campaign_amounts;
  return (
    <>
      <Table className='table min-w-full bg-white'>
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Date</Th>
            <Th>Items</Th>
            <Th className='text-end'>Additional Donation</Th>
            {/* <Th className='text-end'>Total</Th> */}
            <Th className='w-25'>Comment</Th>
          </Tr>
        </Thead>

        <Tbody>
          {registrations.map((registration, index) => {
            const name = `${registration.first_name} ${registration.last_name}`;
            const total =
              parseFloat(registration.total) +
              parseFloat(registration.additional_campaign_amount);
            return (
              <Tr key={index}>
                <Td className='fullwidth'>
                  <div className='fw-bold'>{name}</div>
                  <div className='small'>
                    <div>
                      <a href={`mailto:${registration.email}`}>
                        {registration.email}
                      </a>
                    </div>
                    <div>
                      <a href={`tel:${registration.phone}`}>
                        {registration.phone}
                      </a>
                    </div>
                    <div>
                      {registration.address_1}, {registration.city},{' '}
                      {registration.state} {registration.zip_code}
                    </div>
                  </div>
                </Td>

                <Td>{moment(registration.created_date).format('L')}</Td>
                <Td className='fullwidth'>
                  {registration.registration_details.map((detail, index) => {
                    return (
                      <div
                        key={index}
                        className='d-flex gap-2 justify-content-between'
                      >
                        <div className='w-50'>{detail.item?.name}</div>
                        <div>x{detail.quantity}</div>
                        <div className='w-25'>
                          ${detail.item?.price * detail.quantity}
                        </div>
                      </div>
                    );
                  })}
                </Td>
                <Td className='fullwidth text-end'>
                  {registration.additional_campaign_amount !== '0.00' && (
                    <>${registration.additional_campaign_amount}</>
                  )}
                </Td>
                {/* <Td className='text-end'>${total.toFixed(2)}</Td> */}
                <Td className='fullwidth'>
                  {registration.registration_answer && (
                    <div className='rounded-1 py-1 px-2 bg-lighter small'>
                      {registration.registration_answer}
                    </div>
                  )}
                  {registration.message_to_organizer && (
                    <div className='rounded-1 py-1 px-2 bg-lighter small'>
                      {registration.message_to_organizer}
                    </div>
                  )}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Row className='justify-content-end'>
        <Col lg={9} xl={7} className='px-3 py-2 rounded-1 bg-lighter'>
          <Row className='py-3 border-bottom border-dark'>
            <Col sm={3} className='fw-bold'>
              Total Items
            </Col>
            <Col>
              {item_totals.map((item, index) => {
                return (
                  <div key={index} className='d-flex justify-content-between'>
                    <div>{item.item__name}</div>
                    <div>x{item.quantity}</div>
                  </div>
                );
              })}
            </Col>
            <Col sm={2} className='text-end fw-bold'>
              {item_totals.map((item, index) => {
                return <div key={index}>${item.total}.00</div>;
              })}
            </Col>
          </Row>
          <Row className='justify-content-between py-3 border-bottom border-dark'>
            <Col className='fw-bold'>Additional Campaign Donations</Col>
            <Col className='text-end fw-bold'>
              <div>${additional_campaign_amounts}.00</div>
            </Col>
          </Row>
          <Row className='justify-content-between py-3'>
            <Col className='fw-bold'>Grand Total</Col>
            <Col className='text-end fw-bold'>
              <div>${grandTotal.toFixed(2)}</div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default RegistrationsTable;
